import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { ApiClient } from "@fdoh/health-ui-react";
import { ApiEndpoint } from "./ApiEndpoint";
import { Application } from "../interfaces";
import { JwtResponse } from "../types";

export class InspectionJwtClient extends ApiClient {    
    accountInfo: AccountInfo;
    application: Application;
    jwtResponse?: JwtResponse;
    public constructor(
        account: AccountInfo,
        msalClient: IPublicClientApplication,
        application: Application,
        jwtResponse?: JwtResponse
    ) {
        super(account, msalClient, application);
        this.accountInfo = account;
        this.application = application;
        this.jwtResponse = jwtResponse;
    }
    get account() {
        return this.accountInfo;
    }    
    api = (endpoint: string) =>
        new ApiEndpoint(endpoint, this.tokenOptions, this.application, this.jwtResponse);
    lookups = (name: string) =>
        new ApiEndpoint(`lookups/${name}`, this.tokenOptions, this.application, this.jwtResponse);
    
}

export default InspectionJwtClient;
